
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'GravesOCC',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/GravesOCC.vue